module.exports = __webpack_public_path__ + "fonts/Sahel-Bold.105291c.woff";